import { Box, Button, ButtonGroup, IconButton } from '@mui/material';
import { ButtonTypeLog } from '../../utils';
import { Close } from '@mui/icons-material';
import { LogReportType } from 'ui-component/RecordView/types';

interface LogReportHeaderButtonsProps {
    buttonTypeLog: LogReportType;
    setButtonTypeLog?: (newSelection: LogReportType) => void;
    handleClose: () => void;
}

export const LogReportHeaderButtons = ({ buttonTypeLog, setButtonTypeLog, handleClose }: LogReportHeaderButtonsProps) => (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px'
        }}
    >
        <ButtonGroup
            sx={{
                borderRadius: 8,
                height: 40
            }}
            color="primary"
            aria-label="Logs"
            component="div"
        >
            <Button
                onClick={(e) => setButtonTypeLog?.(ButtonTypeLog.Detail)}
                type="button"
                variant={buttonTypeLog === ButtonTypeLog.Detail ? 'contained' : 'text'}
                color="secondary"
                size="large"
                sx={buttonTypeLog === ButtonTypeLog.Detail ? {} : { bgcolor: 'white' }}
            >
                Detail
            </Button>
            <Button
                onClick={(e) => setButtonTypeLog?.(ButtonTypeLog.Summary)}
                type="button"
                variant={buttonTypeLog === ButtonTypeLog.Summary ? 'contained' : 'text'}
                color="secondary"
                size="large"
                sx={buttonTypeLog === ButtonTypeLog.Summary ? {} : { bgcolor: 'white' }}
            >
                Summary
            </Button>
        </ButtonGroup>

        <IconButton
            sx={{
                bgcolor: 'white',
                width: 40,
                height: 40
            }}
            color="default"
            size="small"
            onClick={handleClose}
        >
            <Close />
        </IconButton>
    </Box>
);
